import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InitializationService {
  initializationComplete = signal<boolean>(false);
}
